import DM from 'DM';
const killAds = DM.Utils.killAds() || DM.Utils.getCookie(DM.Cookies.KillAds) === 'true';
export const showAds = !killAds;
